import { getTodaysDate } from '@usas/ui-web/utils/DateFunctions';

const isRegistrationPeriodInFuture = (registrationStartDate) => {
  const regStartDate = new Date(registrationStartDate);
  const todayDate = new Date(getTodaysDate());

  return todayDate >= regStartDate ? false : true;
};

export { isRegistrationPeriodInFuture };